import CompleteSendEmailCustomer from '../../../../auth/customer/completeSendEmail/completeSendEmail';
const CustomerCompleteChangePassword = () => {
  return <CompleteSendEmailCustomer changePassword={true} />;
};
export default CustomerCompleteChangePassword;
